import { render } from "./SakuraFall.vue?vue&type=template&id=98dbee76&scoped=true&ts=true"
import script from "./SakuraFall.vue?vue&type=script&lang=ts"
export * from "./SakuraFall.vue?vue&type=script&lang=ts"

import "./SakuraFall.vue?vue&type=style&index=0&id=98dbee76&scoped=true&lang=css"

import exportComponent from "/Users/mufeng/Documents/ProjectWorkbench/hotaru_theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98dbee76"]])

export default __exports__